import React from 'react';

const FormInput = ({ name = '', value = '', onValueChange, type = 'text', placeholder = '', suffix, readonly = false, element = undefined }) => {
    return (
        <div className="flex-v mt-16">
            {name !== '' &&
                <div>
                    <h4>{name} :</h4>
                </div>
            }
            <div className="flex-h flex-between">
                <input type={type} value={value} placeholder={placeholder} onChange={e => {
                 onValueChange(e.target.value, element
                 
                        )
                }} readOnly={readonly} />
                {suffix && <h3 className="ml-16">{suffix}</h3>}
            </div>
        </div>
    );
}

export default FormInput;